export default __webpack_public_path__ + "static/media/oxford_logo_.444866e0.webp";